module.exports = __webpack_public_path__ + "img/logo.d133bb27.png";